export default {
  accessTokenKey: 'access_token',
  refreshTokenKey: 'refresh_token',
  tokenRefreshEnabled: process.env.REACT_APP_JWT_REFRESH_ENABLED !== 'false',
  guestRedirectPath: '/frontofficev2/login',
  memberRedirectPath: '/frontofficev2/',
  rootUrl: '/frontofficev2/'
};
